import { render, staticRenderFns } from "./ImageAndText.vue?vue&type=template&id=5b0077b2&scoped=true"
import script from "./ImageAndText.vue?vue&type=script&lang=js"
export * from "./ImageAndText.vue?vue&type=script&lang=js"
import style0 from "./ImageAndText.vue?vue&type=style&index=0&id=5b0077b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0077b2",
  null
  
)

export default component.exports